import { Injectable } from '@angular/core';

export const DEFAULT_LOGO_KEY = 'DEFAULT';

// In-memory cache of customer logo urls delivered in the 'headers.LOGO_BLOBS' element of the projectList api.
// The urls are short-lived SAS urls, so the cache is never persisted and is refreshed on every response.
@Injectable({ providedIn: 'root' })
export class ProjectLogoService {
  private logos: Record<string, string> = {};

  update(logoBlobs?: Record<string, string> | null): void {
    if (logoBlobs) {
      this.logos = { ...this.logos, ...logoBlobs };
    }
  }

  getLogo(customerName?: string | null): string | undefined {
    return (customerName && this.logos[customerName]) || this.logos[DEFAULT_LOGO_KEY];
  }
}
